import { TPhotoSize, IGetBankSettingsAcquirers, IGetMediaFilePathArgs } from 'types';
import { AxiosRequestConfig } from 'axios';
import {
	serviceGetRoles,
	serviceGetLanguages,
	serviceGetCountries,
	serviceGetCities,
	serviceGetActualFilePath,
	serviceGetActualFileObject,
	serviceDownloadBlob,
	servicePostMediaFile,
	servicePostMediaFileForStyleSettings,
	serviceGetCurrencies,
	serviceGetFilePathForMediaFilesWithSizeForStyleSettings,
	serviceGetBankSettingsAcquirers,
	serviceGetBankSettingsAcquirersByRestaurantId,
	serviceGetMediaFilePath,
	serviceGetMediaFilePathMenuV2,
} from 'services/api/additionalInformation';
import { createAppErrorMessage } from 'utils/helpers';

const getRoles = async () => {
	try {
		const response = await serviceGetRoles();
		const filteredRoles = response.data.roles.filter((el: { id: string; name: string }) => el.name !== 'waiter'); // TODO removing unnecessary waiter role for admin panel
		return { data: { roles: filteredRoles } };
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getLanguages = async () => {
	try {
		const response = await serviceGetLanguages();
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getCountries = async () => {
	try {
		const response = await serviceGetCountries();
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getCities = async (countryID: string) => {
	try {
		const response = await serviceGetCities(countryID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getActualFilePath = async (filePath: string) => {
	try {
		const response = await serviceGetActualFilePath(filePath);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getActualFileObject = async (filePath: string) => {
	try {
		const response = await serviceGetActualFileObject(filePath);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const downloadBlob = async (filePath: string) => {
	try {
		const response = await serviceDownloadBlob(filePath);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDownloadingFile');
		throw new Error(errorMessage);
	}
};

const postMediaFile = async ({ data, config }: { data: FormData; config?: AxiosRequestConfig }) => {
	try {
		const response = await servicePostMediaFile({ data, config });
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorAddingMediaFile');
		throw new Error(errorMessage);
	}
};

const postMediaFileForStyleSettings = async (data: FormData) => {
	try {
		const response = await servicePostMediaFileForStyleSettings(data);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorAddingMediaFile');
		throw new Error(errorMessage);
	}
};

const getCurrencies = async () => {
	try {
		const response = await serviceGetCurrencies();
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getFilePathForMediaFilesWithSizeForStyleSettings = async (translationID: string, photoSize: TPhotoSize) => {
	try {
		const response = await serviceGetFilePathForMediaFilesWithSizeForStyleSettings(translationID, photoSize);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getBankSettingsAcquirers = async (args: IGetBankSettingsAcquirers) => {
	try {
		const response = await serviceGetBankSettingsAcquirers(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getBankSettingsAcquirersByRestaurantId = async (restaurantID: string) => {
	try {
		const response = await serviceGetBankSettingsAcquirersByRestaurantId(restaurantID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getMediaFilePath = async (args: IGetMediaFilePathArgs) => {
	try {
		const response = await serviceGetMediaFilePath(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getMediaFilePathMenuV2 = async (args: IGetMediaFilePathArgs) => {
	try {
		const response = await serviceGetMediaFilePathMenuV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

export {
	getRoles,
	getLanguages,
	getCountries,
	getCities,
	getActualFilePath,
	getActualFileObject,
	downloadBlob,
	postMediaFile,
	postMediaFileForStyleSettings,
	getCurrencies,
	getFilePathForMediaFilesWithSizeForStyleSettings,
	getBankSettingsAcquirers,
	getBankSettingsAcquirersByRestaurantId,
	getMediaFilePath,
	getMediaFilePathMenuV2,
};
